import { ref } from 'vue'

// Create a reactive reference that can be shared across components
export const isLoginModalVisible = ref(false)
export const isSaveModalVisible = ref(false)

export const goBack = () => {
  useRouter().back()
}


export const isBase64Image = (str) => {
  try {
    // Check if it's a data URL
    if (str.startsWith('data:image')) return true;

    // Check if it's a raw base64 string
    return /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/.test(str);
  } catch {
    return false;
  }
};

let rawVariations = null;
export const getRawVariations = async () => {
  if (rawVariations) return rawVariations
  rawVariations = await fetchPost('/api/variations')
  return rawVariations
}

export const clearVariationsCache = () => {
  rawVariations = null;
}

export const refreshVariations = async () => {
  rawVariations = null;
  return await getRawVariations();
}

export const tileImage = async (parameters) => {
  const variations = await getRawVariations();

  let variationDetails = {};
  for (let variation of variations) {
    variationDetails[variation.label] = variation;
  }

  if (!parameters) parameters = {};

  let tile;

  if (parameters.tile) {
    tile = parameters.tile;
  }

  let shape = tile.shape.label;

  let photo;

  if (shape == 'Tile') {
    let selector = `${tile.color.label}-${tile.pattern.label}`;

    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }


    if (tile.shape.rotate && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }
  if (shape == 'Pixel') {
    let selector = `Pixel-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }
  if (shape == 'Bit') {
    let selector = `Bit-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }
  if (shape == 'LargeSquare') {
    let selector = `LargeSquare-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }
  if (shape == 'Quarter') {
    let selector = `Quarter-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }
  if (shape == 'Half') {
    let selector = `Half-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    if (tile.shape.modifier == 'Vertical' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }
  if (shape == 'Triangle') {
    let selector = `Triangle-${tile.color.label}`;

    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }

    if (tile.shape.modifier == 'TopLeft' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
    if (tile.shape.modifier == 'TopRight' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
    if (tile.shape.modifier == 'BottomRight' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }
  if (shape == 'Shiplap') {
    let selector = `Shiplap-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    if (tile.shape.modifier == 'Vertical' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }

  if (shape == 'MiniShiplap') {
    let selector = `MiniShiplap-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    if (tile.shape.modifier == 'Vertical' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }

  if (shape == 'LargeHalflap') {
    let selector = `LargeHalflap-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    if (tile.shape.modifier == 'Vertical' && photo) {
      photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    }
  }

  if (shape == 'Hex') {
    let selector = `Hex-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'LargeTriangle') {
    let selector = `LargeTriangle-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'SmallTriangle') {
    let selector = `SmallTriangle-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Diamond') {
    let selector = `Diamond-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    // if(tile.shape.modifier) {
    //   photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    // }
  }

  if (shape == 'LargeDiamond') {
    let selector = `LargeDiamond-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
    // if(tile.shape.modifier) {
    //   photo = photo.replace(`/upload/`, `/upload/a_${tile.shape.rotate}/`);
    // }
  }

  if (shape == 'LargeHalfCircle') {
    let selector = `LargeHalfCircle-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'HalfCircle') {
    let selector = `HalfCircle-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'QuarterCircle') {
    let selector = `QuarterCircle-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Tangent') {
    let selector = `Tangent-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'CrissCross') {
    let selector = `CrissCross-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Knot') {
    let selector = `Knot-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Converge') {
    let selector = `Converge-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Offset') {
    let selector = `Offset-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Topo') {
    let selector = `Topo-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  if (shape == 'Arc') {
    let selector = `Arc-${tile.color.label}`;
    if (variationDetails[selector]) {
      photo = variationDetails[selector].photo;
    } else {
      photo = null;
    }
  }

  let data = {
    image: photo
  }

  return data;
};

export const getImage = (parameters) => {
  if (parameters.image) {
    let image = parameters.image;
    image = image.replace('http://', 'https://');
    let imageSrc = image;
    let parameterArray = [];
    if (parameters.type) {
      parameterArray.push(parameters.type);
    }
    if (parameters.width) {
      parameterArray.push('w_' + parameters.width);
    }
    if (parameters.height) {
      parameterArray.push('h_' + parameters.height);
    }
    if (parameters.quality) {
      parameterArray.push('q_' + parameters.quality);
    }
    var parameterString = parameterArray.join();
    // echo $parameterString;
    if (parameterString) {
      imageSrc = imageSrc.replace('/image/upload/', '/image/upload/' + parameterString + '/');
      // var imageSrc = str_replace('/image/upload/', '/image/upload/'.$parameterString.'/', $imageSrc);
    }
    if (parameterString) {
      imageSrc = imageSrc.replace('/image/upload/', '/image/upload/' + parameterString + '/');

      if (imageSrc.includes('/w_520/') && parameters.width) {
        imageSrc = imageSrc.replace('/w_520/', '/');
      }

      // var imageSrc = str_replace('/image/upload/', '/image/upload/'.$parameterString.'/', $imageSrc);
    }
    if (parameters.format) {
      imageSrc = imageSrc.replace(/.jpg/g, parameters.format);
    }
    return imageSrc;
  }
};